import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["month", "onChange", "value"];
import { equals } from '../../utils/SimpleDate';
import { AbstractMonth } from './AbstractMonth';
import { Day } from './Day';
import { jsx as _jsx } from "react/jsx-runtime";
export const Month = _ref => {
  let {
      month,
      onChange,
      value
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(AbstractMonth, Object.assign({}, rest, {
    month: month,
    onDateClick: onChange,
    children: (simpleDate, dayProps) => {
      const isSelected = equals(simpleDate, value);
      return /*#__PURE__*/_jsx(Day, Object.assign({}, dayProps, {
        isSelected: isSelected,
        children: simpleDate.date
      }));
    }
  }));
};